import { Skeleton, YStack } from '@usepepper/sprout-kit-ui';

const SKELETON_TAB_COUNT = 2;

const SKELETON_ICON_SIZE = 20;
const SKELETON_AVATAR_SIZE = 24;
const SKELETON_LABEL_WIDTH = 38;
const SKELETON_LABEL_HEIGHT = 8;

export const MobileBottomNavSkeleton: React.FC = () => (
  <>
    {Array.from({ length: SKELETON_TAB_COUNT }).map((_, index) => (
      <YStack
        alignItems="center"
        flexBasis={0}
        flexGrow={1}
        flexShrink={1}
        gap="$8"
        key={index}
        minWidth={0}
        paddingVertical="$8"
      >
        <Skeleton
          height={SKELETON_ICON_SIZE}
          variant="circle"
          width={SKELETON_ICON_SIZE}
        />
        <Skeleton
          height={SKELETON_LABEL_HEIGHT}
          variant="rect"
          width={SKELETON_LABEL_WIDTH}
        />
      </YStack>
    ))}
    <YStack
      alignItems="center"
      flexBasis={0}
      flexGrow={1}
      flexShrink={1}
      gap="$8"
      minWidth={0}
      paddingVertical="$8"
    >
      <Skeleton
        height={SKELETON_AVATAR_SIZE}
        variant="circle"
        width={SKELETON_AVATAR_SIZE}
      />
      <Skeleton
        height={SKELETON_LABEL_HEIGHT}
        variant="rect"
        width={SKELETON_LABEL_WIDTH}
      />
    </YStack>
  </>
);
